import React from "react";
export const HeightMap = (props) => {
    return (
            <img alt="" style={{position:'relative',top:'-30px'}} src={require(`../assets/${props.raceName}.png`)}/>
    )
}

